"use client";

import { FetchButton } from "@/fetch-ui/FetchButton";
import { Check } from "lucide-react";

interface PartnerThankYouProps {
  /** Word for what was submitted, e.g. "Company". Shown in the submit-another button. */
  noun: string;
  /** Brings the empty form back, e.g. for a hotel group adding a second property. */
  onSubmitAnother: () => void;
}

/**
 * Thank-you state that replaces the Partner sign-up form after a successful submit.
 * Follows the public form thank-you in `landing-page-v2/_components/public/FormThankYou.tsx`.
 *
 * @param props - See {@link PartnerThankYouProps}.
 * @returns The thank-you state.
 */
export default function PartnerThankYou({ noun, onSubmitAnother }: PartnerThankYouProps) {
  return (
    <div className="flex w-full flex-col items-center gap-6 text-center" role="status">
      <div className="flex flex-col items-center gap-3">
        <div className="flex h-14 w-14 items-center justify-center rounded-full bg-indigo-50">
          <Check className="h-7 w-7 text-indigo-600" strokeWidth={2.5} aria-hidden="true" />
        </div>
        <div className="flex flex-col items-center gap-2">
          <h2 className="text-h4 text-landing-primary">Response received</h2>
          <p className="text-sm font-medium text-gray-600">Thanks for applying to become a Partner.</p>
        </div>
      </div>
      <FetchButton onClick={onSubmitAnother} variant="outline" color="neutral" size="md">
        Submit another {noun.toLowerCase()}
      </FetchButton>
    </div>
  );
}
